import { render, staticRenderFns } from "./index.vue?vue&type=template&id=674a31af&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=674a31af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674a31af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('674a31af')) {
      api.createRecord('674a31af', component.options)
    } else {
      api.reload('674a31af', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=674a31af&scoped=true&", function () {
      api.rerender('674a31af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/submit-application/index.vue"
export default component.exports